import { Auth } from 'aws-amplify'
import toast from '../components/Toast'
const pako = require('pako')

const api = process.env.REACT_APP_API

export default async function lambdaFetch(
  path,
  method,
  webToken,
  body,
  successMessage,
  creds,
  dontShowTimeoutError,
  customErrorMessage,
  signal
) {
  let authToken = webToken;
  if (webToken) {
    try {
      const session = await Auth.currentSession();
      authToken = session.idToken.jwtToken;
    } catch (_) {}
  }

  try {
    const api_key = creds?.apiKey || ''

    const res = await fetch(`${api}/${path}`, {
      timeout: 6000,
      method: method,
      headers: {
        'X-Api-Key': api_key,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`
      },
      body: body,
      signal: signal
    }).then(resp => {
      if (!resp.ok) {
        if (resp.status === 401) {
          creds.login() 
          throw new Error('Your access token has expired. Please log in again.')
        }
        if (resp.status === 504) {
          throw new Error('Timeout error')
        }
        // throw new Error(`Error with status: ${resp.status}`)
      }
      return resp.json()
    })

    if (res.isPacko) {
      const unpackedData = JSON.parse(pako.inflate(res.data, { to: 'string' }))
      res.data = unpackedData
    }

    if(res?.data?.response?.statusCode == 500) {
      const body = res?.data?.response?.body
      const error = JSON.parse(body)?.error
      // Don't show toast for index_not_found_exception - let the caller handle it gracefully
      if (!error || (typeof error === 'string' && !error.includes('index_not_found_exception'))) {
        toast.persist(error ? error : error.toString(), 'error')
      } else {
        // Return error object for index_not_found_exception so caller can handle it
        return { error: error }
      }
      return false
    }

    if (
      res.message ===
      'User is not authorized to access this resource with an explicit deny'
    ) {
      if (path === 'login') {
        return null
      }
      toast.persist(
        'Your access token may be expired. Please try logging back in.',
        'error'
      )
      creds.login()
      return null
    }

    if (res.message === 'Endpoint request timed out' && !dontShowTimeoutError) {
      toast.persist('Timeout error', 'error')
      return false
    }
    // Check for error field (could be direct or when success is false)
    if (res.error || (!res.success && res.error)) {
      // Don't show toast for index_not_found_exception - let the caller handle it gracefully
      const errorMsg = res.error
      if (typeof errorMsg === 'string' && !errorMsg.includes('index_not_found_exception')) {
        toast.persist(errorMsg, 'error')
        return false
      } else {
        // Return error object for index_not_found_exception so caller can handle it
        return { error: errorMsg }
      }
    } else if (res.success && res.data) {
      if (res.data.maxRows) {
        toast.persist(res.data.maxRows, 'warning')
      }
      return res
    } else {
      successMessage && toast.success(successMessage)
      return res
    }
  } catch (e) {
    // Don't show error toast for aborted requests (they're intentional)
    if (e.name === 'AbortError') {
      throw e // Re-throw so caller can handle it
    }
    console.log("fetching error: ", e)
    const errorMessage = customErrorMessage || e.toString()
    // Don't show toast for index_not_found_exception - let the caller handle it gracefully
    if (!errorMessage.includes('index_not_found_exception')) {
      toast.persist(errorMessage, 'error')
    }
    throw e
  }
}
